export const PERSONAL_TEAM_REQUEST = "API/PERSONAL_TEAM/REQUEST";
export const PERSONAL_TEAM_REQUEST_FAILURE =
  "APP/PERSONAL_TEAM/REQUEST_FAILURE";
export const PERSONAL_TEAM_REQUEST_SUCCESS =
  "APP/PERSONAL_TEAM/REQUEST_SUCCESS";
